import React, { useMemo, useState, useEffect, useCallback } from "react";
import Customtable from "../helper/Customtable";
import Swal from "sweetalert2";
import { post } from "../helper/api_helper";

const BillOfEntryReport = () => {
  const [reportList, setReportList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);

  // Filter state
  const [consigneeOptions, setConsigneeOptions] = useState([]);
  const [consigneeId, setConsigneeId] = useState("");
  const [reportType, setReportType] = useState("full"); // "party" | "full"

  // ------------------------------
  // Alert Helper
  // ------------------------------
  const showAlert = useCallback((icon, title, text, timer = 2000) => {
    Swal.fire({
      icon,
      title,
      text: text || "Something went wrong.",
      timer,
      showConfirmButton: false,
    });
  }, []);

  // ------------------------------
  // Fetch Data
  // ------------------------------
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = { report_type: reportType };
      if (reportType === "party" && consigneeId) payload.consignee_id = consigneeId;

      const response = await post("/reports/bill_of_entry_report/list", payload);
      if (response.status === 200) {
        setReportList(response.data || []);
      } else {
        showAlert("error", response.status, response.message);
      }
    } catch (err) {
      showAlert("error", "Unexpected Error", err.message);
    } finally {
      setLoading(false);
    }
  }, [showAlert, consigneeId, reportType]);

  const fetchConsigneeData = useCallback(async () => {
    try {
      const response = await post("/masters/consignees/list");
      if (response.status === 200) {
        setConsigneeOptions([
          { value: "", label: "Select Consignee" },
          ...response.data.map(item => ({
            value: item.consignees_id,
            label: item.consignees_name,
          }))
        ]);
      }
    } catch (err) {
      console.log(err.message);
    }
  }, []);

  useEffect(() => {
    fetchData();
    fetchConsigneeData();
  }, [fetchData, fetchConsigneeData]);

  // ------------------------------
  // Table Columns
  // ------------------------------
  const columns = useMemo(
    () => [
      { header: "S.No", accessorKey: "si_no", enableColumnFilter: false, enableSorting: false },
      { header: "Job No", accessorKey: "job_no" },
      { header: "Consignee", accessorKey: "consignee" },
      { header: "Shipper", accessorKey: "shipper" },
      { header: "POL", accessorKey: "pol" },
      { header: "Desc", accessorKey: "description" },
      { header: "Liner", accessorKey: "liner" },
      { header: "BL No", accessorKey: "bl_number" },
      { header: "TC", accessorKey: "no_of_containers" },
      { header: "T/S Date", accessorKey: "ts_arrival" },
      { header: "Arrival Date", accessorKey: "arrived" },
      { header: "Weight", accessorKey: "weight" },
    ],
    []
  );

  return (
    <>
      <div className="page-header d-flex justify-content-between align-items-center">
        <div>
          <div className="page-header-title">Bill of Entry to be Filed Report</div>
        </div>
      </div>

      {/* Filters */}
      <div className="card mt-3">
        <div className="card-body">
          <div className="row g-3 align-items-end">
            <div className="col-md-3">
              <label className="form-label">Report Type</label>
              <select
                className="form-select"
                value={reportType}
                onChange={(e) => setReportType(e.target.value)}
              >
                <option value="full">Full</option>
                <option value="party">Party Wise</option>
              </select>
            </div>
            {reportType === "party" && (
              <div className="col-md-3">
                <label className="form-label">Consignee</label>
                <select
                  className="form-select"
                  value={consigneeId}
                  onChange={(e) => setConsigneeId(e.target.value)}
                >
                  {consigneeOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="col-md-2">
              <button className="btn btn-primary w-100" onClick={fetchData} disabled={loading}>
                {loading ? "Loading..." : "Search"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="card basic-data-table mt-3">
        <div className="card-header">
          <h5 className="card-title mb-0">Bill of Entry to be Filed - {reportType === "party" ? "Party Wise" : "Full"}</h5>
        </div>
        <div className="card-body">
          <Customtable
            table_title="Bill of Entry to be Filed Report"
            columns={columns}
            data={reportList}
            isGlobalFilter={true}
            isPagination={true}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            isExportButton={true}
          />
        </div>
      </div>
    </>
  );
};

export default BillOfEntryReport;
